import React, { useEffect, useState,useLayoutEffect } from 'react';
import { axiosInstance } from "../../utils/axios";
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import '../ReserveCom/reserve.scss';
import { User, FileText, Calendar, Hash, Type, CheckCircle, Save, AlertTriangle, X, ChevronDown } from 'lucide-react';

const MypageInfoContainer = (props) => {
    const [answers, setAnswers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [missingFields, setMissingFields] = useState([]);
    const navigate = useNavigate();
    const { responseId } = useParams();

    useEffect(() => {
        // APIからquestionnaire_id=1の回答を取得
        axiosInstance
            .get(`/users`, {
                headers: {
                    'uid': props.token,
                    'Access-Control-Allow-Origin': '*'
                }
            })
            .then((response) => {
                console.log(response.data);
                setAnswers(response.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Failed to fetch answers:", error);
                setIsLoading(false);
            });
    }, [responseId]);

    const handleInputChange = (id, value) => {
        setAnswers((prev) =>
            prev.map((a) => (a.id === id ? { ...a, answer_text: value } : a))
        );
    };

    const getQuestionPlaceholder = (answer) => {
        // question_idベースの判定
        const placeholdersByQuestionId = {
            1: "山田太郎",
            2: "やまだたろう",
            3: "example@email.com",
            4: "09012345678（ハイフンなし）",
            5: "生年月日を選択してください",
            7: "170",
            8: "65",
        };
    
        // contentベースの判定
        const contentBasedPlaceholders = {
            "氏名": "山田太郎",
            "ふりがな": "やまだたろう",
            "メールアドレス": "example@email.com",
            "電話番号": "09012345678（ハイフンなし）",
            "身長": "170",
            "体重": "65",
        };
    
        // question_idでまず判定
        if (placeholdersByQuestionId[answer.question_id]) {
            return placeholdersByQuestionId[answer.question_id];
        }
    
        // question_contentで判定
        for (const [keyword, placeholder] of Object.entries(contentBasedPlaceholders)) {
            if (answer.question_content && answer.question_content.includes(keyword)) {
                return placeholder;
            }
        }
    
        // デフォルト
        const typeBasedPlaceholders = {
            text: "詳細をご記入ください",
            sentence: "ご記入ください",
            number: "数値を入力してください",
            date: "日付を選択してください",
        };
    
        return typeBasedPlaceholders[answer.question_type] || "ご記入ください";
    };

    const isPhoneNumberAnswer = (answer) => {
        return answer.question_id === 4 || (answer.question_content && answer.question_content.includes('電話番号'));
    };
    
    // 5. カスタム日付セレクターコンポーネントを追加（コンポーネント内に追加）
    const CustomDateSelect = ({ answer, onChange }) => {
        const dateValue = safeDate(answer.answer_text);
        const [year, setYear] = useState(dateValue ? dateValue.getFullYear() : new Date().getFullYear());
        const [month, setMonth] = useState(dateValue ? dateValue.getMonth() + 1 : new Date().getMonth() + 1);
        const [day, setDay] = useState(dateValue ? dateValue.getDate() : new Date().getDate());
        const [isYearOpen, setIsYearOpen] = useState(false);
        const [isMonthOpen, setIsMonthOpen] = useState(false);
        const [isDayOpen, setIsDayOpen] = useState(false);
    
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
        const months = Array.from({ length: 12 }, (_, i) => i + 1);
        const daysInMonth = new Date(year, month, 0).getDate();
        const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
    
        const updateDate = (y, m, d) => {
            const newDate = new Date(y, m - 1, d);
            onChange(newDate.toISOString());
        };
    
        const handleYearSelect = (selectedYear) => {
            setYear(selectedYear);
            const validDay = Math.min(day, new Date(selectedYear, month, 0).getDate());
            setDay(validDay);
            updateDate(selectedYear, month, validDay);
            setIsYearOpen(false);
        };
    
        const handleMonthSelect = (selectedMonth) => {
            setMonth(selectedMonth);
            const validDay = Math.min(day, new Date(year, selectedMonth, 0).getDate());
            setDay(validDay);
            updateDate(year, selectedMonth, validDay);
            setIsMonthOpen(false);
        };
    
        const handleDaySelect = (selectedDay) => {
            setDay(selectedDay);
            updateDate(year, month, selectedDay);
            setIsDayOpen(false);
        };
    
        // ドロップダウンの外側をクリックしたら閉じる
        useEffect(() => {
            const handleClickOutside = (e) => {
                if (!e.target.closest('.custom-select-wrapper')) {
                    setIsYearOpen(false);
                    setIsMonthOpen(false);
                    setIsDayOpen(false);
                }
            };
            
            document.addEventListener('click', handleClickOutside);
            return () => document.removeEventListener('click', handleClickOutside);
        }, []);
    
        return (
            <div className="mypage_info_modern_date_selector">
                <div className="date-icon-wrapper">
                    <Calendar className="date-icon" />
                </div>
                
                <div className="date-selects-container">
                    {/* 年選択 */}
                    <div className="custom-select-wrapper">
                        <div 
                            className={`custom-select-trigger ${isYearOpen ? 'active' : ''}`}
                            onClick={() => {
                                setIsYearOpen(!isYearOpen);
                                setIsMonthOpen(false);
                                setIsDayOpen(false);
                            }}
                        >
                            <span className="select-value">{year}</span>
                            <ChevronDown className="select-arrow" />
                        </div>
                        {isYearOpen && (
                            <div className="custom-select-dropdown year-dropdown">
                                {years.map(y => (
                                    <div 
                                        key={y} 
                                        className={`select-option ${y === year ? 'selected' : ''}`}
                                        onClick={() => handleYearSelect(y)}
                                    >
                                        {y}
                                    </div>
                                ))}
                            </div>
                        )}
                        <span className="date-label">年</span>
                    </div>
    
                    {/* 月選択 */}
                    <div className="custom-select-wrapper">
                        <div 
                            className={`custom-select-trigger ${isMonthOpen ? 'active' : ''}`}
                            onClick={() => {
                                setIsMonthOpen(!isMonthOpen);
                                setIsYearOpen(false);
                                setIsDayOpen(false);
                            }}
                        >
                            <span className="select-value">{month}</span>
                            <ChevronDown className="select-arrow" />
                        </div>
                        {isMonthOpen && (
                            <div className="custom-select-dropdown month-dropdown">
                                {months.map(m => (
                                    <div 
                                        key={m} 
                                        className={`select-option ${m === month ? 'selected' : ''}`}
                                        onClick={() => handleMonthSelect(m)}
                                    >
                                        {m}
                                    </div>
                                ))}
                            </div>
                        )}
                        <span className="date-label">月</span>
                    </div>
    
                    {/* 日選択 */}
                    <div className="custom-select-wrapper">
                        <div 
                            className={`custom-select-trigger ${isDayOpen ? 'active' : ''}`}
                            onClick={() => {
                                setIsDayOpen(!isDayOpen);
                                setIsYearOpen(false);
                                setIsMonthOpen(false);
                            }}
                        >
                            <span className="select-value">{day}</span>
                            <ChevronDown className="select-arrow" />
                        </div>
                        {isDayOpen && (
                            <div className="custom-select-dropdown day-dropdown">
                                {days.map(d => (
                                    <div 
                                        key={d} 
                                        className={`select-option ${d === day ? 'selected' : ''}`}
                                        onClick={() => handleDaySelect(d)}
                                    >
                                        {d}
                                    </div>
                                ))}
                            </div>
                        )}
                        <span className="date-label">日</span>
                    </div>
                </div>
            </div>
        );
    };


    const getUnitForAnswer = (answer) => {
        // question_idベースの判定
        if (answer.question_id === 7) return 'cm';
        if (answer.question_id === 8) return 'kg';
        
        // contentベースの判定
        if (answer.question_content) {
            if (answer.question_content.includes('身長')) return 'cm';
            if (answer.question_content.includes('体重')) return 'kg';
            if (answer.question_content.includes('最高血圧') || answer.question_content.includes('最低血圧')) {
                return 'mmHg';
            }
        }
        
        return '';
    };

    // バリデーション関数を拡張して、漏れている項目を返す
    const validateForm = () => {
        const missing = [];
        
        answers.filter((answer) => ![9, 10, 11].includes(answer.question_id)).forEach(answer => {
            if (answer.required) {
                let isEmpty = false;
                
                if (answer.question_type === "multiple_choice") {
                    isEmpty = !answer.answer_text || answer.answer_text.length === 0;
                } else if (answer.question_type === "single_choice") {
                    isEmpty = !answer.answer_text;
                } else {
                    isEmpty = !answer.answer_text || answer.answer_text.toString().trim() === "";
                }
                
                if (isEmpty) {
                    missing.push({
                        id: answer.id,
                        question: answer.question_content,
                        type: answer.question_type
                    });
                }
            }
        });
        
        return missing;
    };

    const isFormValid = () => {
        return validateForm().length === 0;
    };

    const handleChoiceChange = (id, choiceId, isChecked) => {
        setAnswers((prev) =>
            prev.map((a) =>
                a.id === id
                    ? {
                        ...a,
                        answer_text: isChecked
                            ? [...(a.answer_text || []), choiceId]
                            : a.answer_text.filter((c) => c !== choiceId)
                    }
                    : a
            )
        );
    };

    const safeDate = (val) => {
        if (!val) return null;
        try {
          if (/^\d{8}$/.test(val)) {
            val = `${val.slice(0,4)}-${val.slice(4,6)}-${val.slice(6,8)}`
          }
          const d = new Date(val);
          return isNaN(d) ? null : d;
        } catch {
          return null;
        }
    };

    const handleImageChange = (id, file) => {
        setAnswers((prev) =>
            prev.map((a) => (a.id === id ? { ...a, file } : a))
        );
    };

    // 更新ボタンクリック時の処理を変更
    const handleSubmitAttempt = () => {
        const missing = validateForm();
        
        if (missing.length > 0) {
            setMissingFields(missing);
            setShowValidationModal(true);
        } else {
            handleSubmit();
        }
    };

    const handleSubmit = () => {
        setIsLoading(true);
        const payload = {
            answers: answers.map(answer => ({
                id: answer.id,
                question_id: answer.question_id,
                answer_text: Array.isArray(answer.answer_text)
                    ? JSON.stringify(answer.answer_text)
                    : answer.answer_text,
            })),
        };

        axiosInstance
            .put(`/users/1`, {payload,access_token: props.token}, {
                headers: { "Content-Type": "multipart/form-data",'uid': props.token, },
            })
            .then(() => {
                setIsLoading(false);
                navigate('/mypage/other', { state: { showModal: true } });
            })
            .catch((error) => {
                console.error("Failed to update answers:", error);
                setIsLoading(false);
            });
    };

    // 該当する質問にスクロールする関数
    const scrollToQuestion = (questionId) => {
        setShowValidationModal(false);
        const element = document.querySelector(`[data-question-id="${questionId}"]`);
        if (element) {
            element.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center' 
            });
            // ハイライト効果を追加
            element.classList.add('mypage_info_edit_highlight_missing');
            setTimeout(() => {
                element.classList.remove('mypage_info_edit_highlight_missing');
            }, 3000);
        }
    };

    // 質問タイプに応じたアイコンを返す関数
    const getQuestionTypeIcon = (type) => {
        switch(type) {
            case 'date': return <Calendar className="mypage_info_edit_validation_question_icon" />;
            case 'number': return <Hash className="mypage_info_edit_validation_question_icon" />;
            case 'text': return <FileText className="mypage_info_edit_validation_question_icon" />;
            case 'sentence': return <Type className="mypage_info_edit_validation_question_icon" />;
            case 'single_choice':
            case 'multiple_choice': return <CheckCircle className="mypage_info_edit_validation_question_icon" />;
            default: return <FileText className="mypage_info_edit_validation_question_icon" />;
        }
    };

    if (isLoading) {
        return (
            <div>
                <div className="loader" style={{ width: '100px', height: '100px' }}></div>
                <div
                    style={{
                        width: '100%',
                        position: 'absolute',
                        bottom: '0%',
                        height: '80px',
                        background: '#FEFBF9',
                        zIndex: '12',
                    }}
                />
            </div>
        );
    }

    return (
        <div className="sunny_container">
            <div className="mypage_info_edit_page">
                <div className="mypage_info_edit_page_header">
                    <User className="mypage_info_edit_page_header_icon" />
                    <h2>基本情報編集</h2>
                </div>

                <div className="mypage_info_edit_questionnaire">
                    {answers.length > 0 ? (
                        answers.filter((answer) => ![9, 10, 11].includes(answer.question_id)).map((answer) => (
                            <div 
                                key={answer.id} 
                                className="mypage_info_edit_question"
                                data-question-id={answer.id}
                            >
                                <div className="mypage_info_edit_question_header">
                                    {answer.question_type === 'date' && <Calendar className="mypage_info_edit_question_icon" />}
                                    {answer.question_type === 'number' && <Hash className="mypage_info_edit_question_icon" />}
                                    {answer.question_type === 'text' && <FileText className="mypage_info_edit_question_icon" />}
                                    {answer.question_type === 'sentence' && <Type className="mypage_info_edit_question_icon" />}
                                    {(answer.question_type === 'single_choice' || answer.question_type === 'multiple_choice') && <CheckCircle className="mypage_info_edit_question_icon" />}
                                    
                                    <p className="mypage_info_edit_question_title">
                                        {answer.question_content}
                                        {answer.required && <span className="mypage_info_edit_required_mark"> ※必須</span>}
                                    </p>
                                </div>

                                <div className="mypage_info_edit_answer_container">
                                    {answer.question_type === 'single_choice' && answer.choices.map(choice => (
                                        <label
                                            key={choice.id}
                                            className={`mypage_info_edit_choice_option ${answer.answer_text == choice.id ? "mypage_info_edit_selected" : ""}`}
                                            onClick={() => handleInputChange(answer.id, choice.id)}
                                        >
                                            <input
                                                type="radio"
                                                name={`question-${answer.id}`}
                                                value={choice.id}
                                                checked={answer.answer_text == choice.id}
                                                onChange={() => handleInputChange(answer.id, choice.id)}
                                                style={{ display: "none" }}
                                            />
                                            <div className="mypage_info_edit_choice_content">
                                                <div className="mypage_info_edit_choice_indicator"></div>
                                                <span>{choice.choice_text}</span>
                                            </div>
                                        </label>
                                    ))}

                                    {answer.question_type === 'multiple_choice' && answer.choices.map(choice => (
                                        <label
                                            key={choice.id}
                                            className={`mypage_info_edit_choice_option mypage_info_edit_multiple ${answer.answer_text?.includes(choice.id.toString()) ? "mypage_info_edit_selected" : ""}`}
                                        >
                                            <input
                                                type="checkbox"
                                                value={choice.id}
                                                checked={answer.answer_text?.includes(choice.id.toString()) || false}
                                                onChange={(e) => handleChoiceChange(answer.id, choice.id.toString(), e.target.checked)}
                                                style={{ display: "none" }}
                                            />
                                            <div className="mypage_info_edit_choice_content">
                                                <div className="mypage_info_edit_choice_indicator mypage_info_edit_checkbox"></div>
                                                <span>{choice.choice_text}</span>
                                            </div>
                                        </label>
                                    ))}

                                        {answer.question_type === 'text' && (
                                            <textarea
                                                value={answer.answer_text || ''}
                                                onChange={(e) => handleInputChange(answer.id, e.target.value)}
                                                className="mypage_info_edit_textarea"
                                                rows={6}
                                                placeholder={getQuestionPlaceholder(answer)}
                                            />
                                        )}
                                    
                                        {answer.question_type === 'sentence' && (
                                        <input
                                            type="text"
                                            value={answer.answer_text || ''}
                                            onChange={(e) => handleInputChange(answer.id, e.target.value)}
                                            className="mypage_info_edit_input"
                                            placeholder={getQuestionPlaceholder(answer)}
                                        />
                                    )}
                                    
                                    {answer.question_type === 'number' && (
                                        <div className="mypage_info_edit_number_wrapper">
                                            <div className="mypage_info_edit_number_with_unit">
                                                <input
                                                    type="number"
                                                    value={answer.answer_text || ''}
                                                    onChange={(e) => handleInputChange(answer.id, e.target.value)}
                                                    className={isPhoneNumberAnswer(answer) ? "mypage_info_edit_number_input_full" : "mypage_info_edit_number_input_short"}
                                                    placeholder={getQuestionPlaceholder(answer)}
                                                />
                                                {!isPhoneNumberAnswer(answer) && getUnitForAnswer(answer) && (
                                                    <span className="mypage_info_edit_input_unit">
                                                        {getUnitForAnswer(answer)}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    
                                    {answer.question_type === 'date' && (
                                            <CustomDateSelect 
                                                answer={answer}
                                                onChange={(date) => handleInputChange(answer.id, date)}
                                            />
                                        )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="mypage_info_edit_no_data">
                            <FileText className="mypage_info_edit_no_data_icon" />
                            <p>回答がありません。</p>
                        </div>
                    )}
                </div>

                <div className="footer_content_page">
                    <button
                        onClick={handleSubmitAttempt}
                        className={`modern_action_button ${isFormValid() ? "active" : "disabled"}`}
                    >
                        <Save className="button_icon" />
                        更新する
                    </button>
                </div>

                {/* バリデーションエラーモーダル */}
                {showValidationModal && (
                    <div className="mypage_info_edit_modal_overlay" onClick={() => setShowValidationModal(false)}>
                        <div className="mypage_info_edit_modal_content" onClick={(e) => e.stopPropagation()}>
                            <div className="mypage_info_edit_modal_header">
                                <AlertTriangle className="mypage_info_edit_validation_modal_icon" />
                                <h3>入力が必要な項目があります</h3>
                                <button 
                                    className="mypage_info_edit_close_button"
                                    onClick={() => setShowValidationModal(false)}
                                >
                                    <X className="mypage_info_edit_close_icon" />
                                </button>
                            </div>

                            <div className="mypage_info_edit_validation_content">
                                <p className="mypage_info_edit_validation_message">
                                    以下の必須項目にご入力ください：
                                </p>

                                <div className="mypage_info_edit_missing_fields_list">
                                    {missingFields.map((field, index) => (
                                        <div 
                                            key={field.id}
                                            className="mypage_info_edit_missing_field_item"
                                            onClick={() => scrollToQuestion(field.id)}
                                        >
                                            {getQuestionTypeIcon(field.type)}
                                            <div className="mypage_info_edit_field_info">
                                                <span className="mypage_info_edit_field_question">{field.question}</span>
                                                <span className="mypage_info_edit_field_action">タップして移動</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="mypage_info_edit_validation_actions">
                                    <button 
                                        className="mypage_info_edit_validation_close_button"
                                        onClick={() => setShowValidationModal(false)}
                                    >
                                        確認して入力する
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MypageInfoContainer;